import React, { useEffect, useState } from "react";
import Notification from "../../../components/Notification";
import MensagemListaVazia from "../../../components/Mensagem/MensagemListaVazia";
import Table from "../../../components/Table/Table";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { withStyles } from "@material-ui/core";
import { pageConfiguracoes } from "../../../utils/getPageTitle";
import HeaderConfiguracoes from "../../../components/Header/HeaderConfiguracoes";
import { columns } from "./Constants";
import ModalExameSelecionado from "./Components/ModalExameSelecionado";
import { inject } from "mobx-react";
import { findAllModalidadeExame } from "../../../services/ExamePacswebService";

const ExamesPacsweb = ({ classes, exameStore }) => {
  const [exames, setExames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [openModalExame, setOpenModalExame] = useState(false);
  const [exameSelecionado, setExameSelecionado] = useState(null);
  const [pageableDTO, setPageableDTO] = useState({
    pageSize: 30,
    pageNumber: 0,
    sortDir: "ASC",
    sortField: "nome",
  });

  useEffect(() => {
    loadExames({ isClear: true });
  }, [pageableDTO.sortDir]);

  const loadExames = async ({ isClear, isClearSearch }) => {
    if (loading) return;
    try {
      setLoading(true);
      const response = await findAllModalidadeExame();
      
      const filteredExames = isClearSearch || !search 
        ? response 
        : response.filter(e => e.descricao?.toLowerCase().includes(search.toLowerCase()));

      setExames(filteredExames);
    } catch (error) {
      exameStore.openNotification("Erro ao carregar exames!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleClickSearch = () => {
    setPageableDTO({ ...pageableDTO, pageNumber: 0 });
    loadExames({ isClear: true });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && search.length >= 3) {
      handleClickSearch();
    }
  };

  const handleClickExame = (exame) => {
    setExameSelecionado(exame);
    setOpenModalExame(true);
  };

  const handleClickOrdenar = (e) => {
    setPageableDTO({
      ...pageableDTO,
      sortDir: pageableDTO.sortDir === "ASC" ? "DESC" : "ASC",
      pageNumber: 0,
    });
  };

  const handleClickClear = () => {
    setSearch("");
    loadExames({ isClear: true, isClearSearch: true });
  };

  const { notification, closeNotification } = exameStore;
  const { isOpen, message, variant } = notification;

  return (
    <div className={classes.container}>
      <PageTitle title={pageConfiguracoes("Exames Pacsweb")} />
      <HeaderConfiguracoes
        showSearch
        placeholderSearch="Pesquisa por nome"
        handleClickSearch={handleClickSearch}
        handleClickClear={handleClickClear}
        onChangeSearch={(e) => setSearch(e?.target?.value)}
        onKeypressSearch={handleKeyPress}
        valueSearch={search}
      />
      <div className={classes.tableContainer}>  
          <Table
            dados={exames}
            columns={columns}
            clickable={true}
            ordenarTabela={{
              sortField: pageableDTO.sortField,
              sortDir: pageableDTO.sortDir,
            }}
            comOrdenacao
            handleClickOrdenar={handleClickOrdenar}
            getDadosRow={handleClickExame}
          />
          {exames?.length === 0 && !loading && (
            <div className={classes.notFoundContainer}>
              <MensagemListaVazia />
            </div>
          )}
       
      </div>

      {openModalExame && (
        <ModalExameSelecionado
          open={openModalExame}
          handleClose={() => setOpenModalExame(false)}
          exameSelecionado={exameSelecionado}
          onSave={() => loadExames({ isClear: true })}
        />
      )}

      <Notification
        close={closeNotification}
        reset={closeNotification}
        isOpen={isOpen}
        variant={variant}
        message={message}
      />
    </div>
  );
};

const styles = (theme) => ({
  container: {
    padding: "0 20px",
  },
  tableContainer: {
    marginTop: "20px",
    height: "calc(100vh - 148px)",
    overflowX: "scroll"
  },
  scrollContainer: {
    height: "100%",
  },
  notFoundContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
});

const ExamesPacswebWithStyles = withStyles(styles)(ExamesPacsweb);
export default inject("exameStore")(ExamesPacswebWithStyles);
